import React from 'react'
import { Container } from './styles'
import logoImage from '../../assets/logo_previ.png'

const Logo: React.FC = () => {
  return <Container src={logoImage} alt="basf" />
}

export default Logo
